<template>
  <div>

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            Formulario de edición de usuarios
            <div class="card-actions">
              <button class="btn btn-primary" v-b-tooltip.hover title="Volver a Gestión de Usuarios" v-if="!procesando" @click="gestionUsuarios()" >
                <i class="icon-arrow-left"></i>
              </button>
            </div>
          </div>
          <div class="card-body">

            <form v-on:submit.prevent="editarUsuario" v-if="procesando == false && error == false">

              <h2>Datos de identificación</h2>
              <hr />

              <b-row>
                <b-col sm="6">
                  <b-form-group>
                    <label for="primer_nombre">Primer nombre</label>
                    <b-form-input type="text" :state="validarPrimerNombre()" v-model="usuario.primer_nombre" name="primer_nombre" :disabled="procesando" placeholder="Ingrese primer nombre"></b-form-input>
                    <b-form-valid-feedback>
                      Primer nombre válido.
                    </b-form-valid-feedback>
                    <b-form-invalid-feedback>
                      Ingrese primer nombre válido. Ej: Pedro
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group>
                    <label for="segundo_nombre">Segundo nombre</label>
                    <b-form-input type="text" :state="validarSegundoNombre()" v-model="usuario.segundo_nombre" name="segundo_nombre" :disabled="procesando" placeholder="Ingrese segundo nombre"></b-form-input>
                    <b-form-valid-feedback>
                      Segundo nombre válido.
                    </b-form-valid-feedback>
                    <b-form-invalid-feedback>
                      Ingrese segundo nombre válido. Ej: Pablo
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="6">
                  <b-form-group>
                    <label for="primer_apellido">Primer apellido</label>
                    <b-form-input type="text" :state="validarPrimerApellido()" v-model="usuario.primer_apellido" name="primer_apellido" :disabled="procesando" placeholder="Ingrese primer apellido"></b-form-input>
                    <b-form-valid-feedback>
                      Primer apellido válido.
                    </b-form-valid-feedback>
                    <b-form-invalid-feedback>
                      Ingrese primer apellido válido. Ej: Vargas
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group>
                    <label for="segundo_apellido">Segundo apellido</label>
                    <b-form-input type="text" :state="validarSegundoApellido()" v-model="usuario.segundo_apellido" name="segundo_apellido" :disabled="procesando" placeholder="Ingrese segundo apellido"></b-form-input>
                    <b-form-valid-feedback>
                      Segundo apellido válido.
                    </b-form-valid-feedback>
                    <b-form-invalid-feedback>
                      Ingrese segundo apellido válido. Ej: Carvajal
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="6">
                  <b-form-group>
                    <label for="genero">Genero</label>
                    <b-form-select class="form-control" :state="validarGenero()" name="genero" :disabled="procesando" v-model="usuario.genero">
                      <option disabled value="">Seleccione genero</option>
                      <option v-for="genero in generos" v-bind:value="genero.codigo">
                        {{ genero.nombre }}
                      </option>
                    </b-form-select>
                    <b-form-valid-feedback>
                      Género válido.
                    </b-form-valid-feedback>
                    <b-form-invalid-feedback>
                      Seleccione un género válido.
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-form-group>
                    <label for="fecha_nacimiento">Fecha de nacimiento</label>
                    <br />
                    <datepicker v-model="fecha_nacimiento" :value="usuario.fecha_nacimiento" type="date" :editable="false" :lang="'es'" @change="obtenerFechaNacimiento()" :format="'DD/MM/YYYY'" :clearable="false" :not-after="obtenerFechaNacimientoRestriccion()"></datepicker>
                    <b-form-input type="text" :state="validarFechaNacimiento()" v-model="usuario.fecha_nacimiento" name="fecha_nacimiento" v-show="false" :disabled="procesando" placeholder="Ingrese fecha de nacimiento"></b-form-input>
                    <b-form-valid-feedback>
                      Fecha de nacimiento válida.
                    </b-form-valid-feedback>
                    <b-form-invalid-feedback>
                      Debe seleccionar una fecha de nacimiento válida.
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-card class="bg-info text-center">
                    Recuerde que Ud debe tener una edad mínima de 10 años.
                  </b-card>
                </b-col>
              </b-row>

              <h2>Datos de acceso </h2>
              <hr />

              <b-row>
                <b-col sm="6">
                  <b-form-group>
                    <label for="correo_electronico">Correo electrónico</label>
                    <b-form-input type="email" :state="validarCorreoElectronico()" v-model="usuario.correo_electronico" name="correo_electronico" :disabled="procesando" placeholder="Ingrese correo electrónico"></b-form-input>
                    <b-form-valid-feedback>
                      Correo electrónico válido.
                    </b-form-valid-feedback>
                    <b-form-invalid-feedback>
                      Ingrese un correo electrónico válido. Ej: correo@dominio.com
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group>
                    <label for="confirmacion_correo_electronico">Confirmación correo electrónico</label>
                    <b-form-input type="email" :state="validarConfirmacionCorreoElectronico()" v-model="usuario.confirmacion_correo_electronico" name="confirmacion_correo_electronico" :disabled="procesando" placeholder="Ingrese confirmación correo electrónico"></b-form-input>
                    <b-form-valid-feedback>
                      Confirmación correo electrónico válida.
                    </b-form-valid-feedback>
                    <b-form-invalid-feedback>
                      Ingrese confirmación correo electrónico.
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>

              <h2>Personalización avatar</h2>
              <hr />

              <br />
              <br />

              <b-row>
                <b-col sm="6" class="text-center">
                  <img :src="'static/img/avatars/' + usuario.ruta_imagen_usuario" style="width: 200px; height: 200px;" class="img-avatar" alt="Avatar seleccionado">
                </b-col>
                <b-col sm="6">
                  <b-list-group>
                    <b-list-group-item v-for="(avatar, index) in avatares" :key="avatar.ruta_imagen_usuario" :active="avatar.active" :disabled="avatar.disabled" @click="seleccionarOpcionAvatar(index)" style="cursor: pointer;" class="d-flex justify-content-between align-items-center">
                      {{avatar.opcion}}
                      <img :src="'static/img/avatars/' + avatar.ruta_imagen_usuario" style="width: 30px; height: 30px;" class="img-avatar" alt="Avatar por defecto">
                    </b-list-group-item>
                    <!-- <b-list-group-item @click="seleccionarOpcionAvatar(3)" style="cursor: pointer;" class="d-flex justify-content-between align-items-center">
                      Avatar personalizado
                      <img src="static/img/avatars/anonymous.png" style="width: 30px; height: 30px;" class="img-avatar" alt="Avatar femenino">
                    </b-list-group-item> -->
                  </b-list-group>

                </b-col>
              </b-row>

              <br />
              <br />

              <h2>Guardar información actualizada</h2>
              <hr />

              <!-- <pre>{{usuario}}</pre> -->

              <b-row>
                <b-col sm="2">
                  <b-form-group>
                    <label for="abreviatura">Activo</label>
                    <br>
                    <c-switch type="text" size="lg" variant="success" on="Si" off="No" v-model="usuario.activo" name="activo" :disabled="procesando" :checked="usuario.activo"/>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="12">
                  <b-form-group>
                    <b-button type="button" variant="secondary" style="cursor: not-allowed;" disabled v-if="!validarFormulario ()" v-b-tooltip.hover title="Crear cuenta de usuario"><i class="fa fa-floppy-o fa-lg"></i></b-button>
                    <b-button type="submit" variant="primary" v-if="validarFormulario ()" v-b-tooltip.hover title="Crear cuenta de usuario"><i class="fa fa-floppy-o fa-lg"></i></b-button>
                  </b-form-group>
                </b-col>
              </b-row>

            </form>
            <b-alert show class="text-center" variant="info" v-else-if="procesando == true">
              <b-progress height="20px" :max="100" variant="info" striped :animated="true">
                <b-progress-bar :value="100" :label="'&lt;strong&gt;Procesando...&lt;/strong&gt;'">
                </b-progress-bar>
              </b-progress>
            </b-alert>
            <b-alert show class="text-center" variant="danger" v-else-if="procesando == false && error == true">
              {{mensaje_error}}
            </b-alert>

          </div>
        </div>
      </div>
      <!--/.col-->
    </div>
    <!--/.row-->

  </div>
</template>

<script>
import router from '@/router/index.js'
import usuario from '@/js/usuario.js'
import genero from '@/js/genero.js'
import cSwitch from '@/components/Switch'
import Datepicker from 'vue2-datepicker'
import moment from 'moment'

import validationField from 'validationField'

export default {
  name: 'editar-usuario',
  components: {
    cSwitch,
    'datepicker': Datepicker,
    moment
  },
  mounted () {
    let cargarPagina = true

    // Verificando que exista datos_usuario
    if (sessionStorage.getItem('datos_usuario')) {
      this.usuario = JSON.parse(sessionStorage.getItem('datos_usuario'))
    } else {
      cargarPagina = false
      this.gestionUsuarios()
    }

    if (cargarPagina) {
      this.procesando = false
      this.error = false

      this.listarGeneros()
    }
  },
  data () {
    return {
      procesando: true,
      error: false,
      mensaje_error: 'Se ha presentado un error en el sistema. Por favor intente más tarde. Si el error continua por favor comuníquese con el administrador del sistema.',
      generos: [],
      avatares: [
        {
          item: 0,
          opcion: 'Anónimo',
          ruta_imagen_usuario: 'registered.jpeg',
          active: true,
          disabled: false
        },
        // {
        //   item: 1,
        //   opcion: 'Avatar masculino',
        //   ruta_imagen_usuario: 'masculino.png',
        //   active: false,
        //   disabled: false
        // },
        // {
        //   item: 2,
        //   opcion: 'Avatar femenino',
        //   ruta_imagen_usuario: 'femenino.png',
        //   active: false,
        //   disabled: false
        // },
        {
          item: 3,
          opcion: 'Personalizado',
          ruta_imagen_usuario: 'personalizado.jpeg',
          active: true,
          disabled: false
        }
      ],
      fecha_nacimiento: this.obtenerFechaNacimientoRestriccion(),
      usuario: {}
    }
  },
  computed: {
    activo: {
      get () {
        return this.usuario.activo === true
      },
      set (newValue) {
        this.usuario.activo = newValue
      }
    }
  },
  methods: {
    listarGeneros () {
      this.procesando = true
      this.error = false

      genero.getListadoGeneros().then(response => {
        if (response.status === 'success') {
          this.procesando = false
          this.error = false

          this.generos = response.data

          this.obtenerUsuario()
        } else {
          this.procesando = false
          this.error = true
          // console.log(response)
        }
      })
    },
    obtenerUsuario () {
      this.procesando = true
      this.error = false

      usuario.codigo_usuario = this.usuario.codigo
      usuario.getUsuario().then(response => {
        if (response.status === 'success') {
          this.procesando = false
          this.error = false

          response.data['confirmacion_correo_electronico'] = response.data.correo_electronico
          this.usuario = response.data

          this.fecha_nacimiento = moment(this.usuario.fecha_nacimiento, 'YYYY-MM-DD').format('MM-DD-YYYY')
          this.validarFechaNacimiento()

          this.seleccionarAvatarSeleccionado(this.usuario.ruta_imagen_usuario)
        } else {
          this.procesando = false
          this.error = true
          // console.log(response)
        }
      })
    },
    validarFormulario () {
      let valido = true

      if (
        !this.validarPrimerNombre() ||
        !this.validarSegundoNombre() ||
        !this.validarPrimerApellido() ||
        !this.validarSegundoApellido() ||
        !this.validarGenero() ||
        !this.validarFechaNacimiento() ||
        !this.validarCorreoElectronico() ||
        !this.validarConfirmacionCorreoElectronico()
      ) {
        valido = false
      }
      return valido
    },
    validarPrimerNombre () {
      let valido = true

      if (!this.usuario.primer_nombre || !validationField('short-string', this.usuario.primer_nombre)) {
        valido = false
      }
      return valido
    },
    validarSegundoNombre () {
      let valido = true

      if (this.usuario.segundo_nombre && !validationField('short-string', this.usuario.segundo_nombre)) {
        valido = false
      }
      return valido
    },
    validarPrimerApellido () {
      let valido = true

      if (!this.usuario.primer_apellido || !validationField('short-string', this.usuario.primer_apellido)) {
        valido = false
      }
      return valido
    },
    validarSegundoApellido () {
      let valido = true

      if (this.usuario.segundo_apellido && !validationField('short-string', this.usuario.segundo_apellido)) {
        valido = false
      }
      return valido
    },
    validarGenero () {
      let valido = true

      if (!this.usuario.genero) {
        valido = false
      }
      return valido
    },
    obtenerFechaNacimiento () {
      this.usuario.fecha_nacimiento = moment(this.fecha_nacimiento).format('YYYY-MM-DD')
    },
    obtenerFechaNacimientoPermitida () {
      return moment().add(-10, 'year').add(-1, 'day').format('YYYY-MM-DD')
    },
    obtenerFechaNacimientoRestriccion () {
      return moment().add(-10, 'year').add(0, 'day').format('YYYY-MM-DD')
    },
    validarFechaNacimiento () {
      let valido = true

      if (!this.usuario.fecha_nacimiento || this.usuario.fecha_nacimiento >= this.obtenerFechaNacimientoRestriccion()) {
        valido = false
      }
      return valido
    },
    validarCorreoElectronico () {
      let valido = true

      if (!this.usuario.correo_electronico || !validationField('email', this.usuario.correo_electronico)) {
        valido = false
      }
      return valido
    },
    validarConfirmacionCorreoElectronico () {
      let valido = true

      if (!this.usuario.confirmacion_correo_electronico || this.usuario.confirmacion_correo_electronico !== this.usuario.correo_electronico) {
        valido = false
      }
      return valido
    },
    seleccionarAvatarSeleccionado (seleccionado) {
      let avatar = this.avatares.filter(
        function (avatar) {
          return avatar.ruta_imagen_usuario === seleccionado
        }
      )

      this.avatares.forEach(function (avatar, value) {
        avatar.active = false
      })

      if (avatar.length === 0) {
        this.avatares[3].opcion = 'Personalizado'
        this.avatares[3].ruta_imagen_usuario = this.usuario.ruta_imagen_usuario
        this.avatares[3].active = true
        this.avatares[3].disabled = false
      } else {
        this.avatares[avatar[0].item].active = true
      }
    },
    seleccionarOpcionAvatar (opcion) {
      if (!this.avatares[opcion].disabled) {
        this.avatares.forEach(function (avatar, value) {
          avatar.active = false
        })

        this.avatares[opcion].active = true
        this.usuario.ruta_imagen_usuario = this.avatares[opcion].ruta_imagen_usuario
      }
    },
    editarUsuario () {
      this.procesando = true
      this.error = false

      usuario.codigo_usuario = this.usuario.codigo
      usuario.usuario = this.usuario
      usuario.putUsuario().then(response => {
        if (response.status === 'success') {
          this.procesando = false
          this.error = false

          this.usuario = response

          router.push({
            name: 'gestion-usuarios-listado-usuarios'
          })
        } else {
          this.procesando = false
          this.error = true
          // console.log(response)
        }
      })
    },
    gestionUsuarios () {
      router.push({
        name: 'gestion-usuarios-listado-usuarios'
      })
    }
  }

}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/views/Usuario/Editar.vue